export default function (totalCharge, quantity, transactionId) {
  fbq(
    "track",
    "Purchase",
    {
      // Per John Groves
      value: totalCharge * 0.9,
      currency: "USD",
      content_ids: [transactionId],
      content_type: "product",
    },
    {
      eventID: transactionId,
    },
  );
}
